import '../scss/App.scoped.scss';

function FormComplete({pComplete}) {
  return (
    <div className="drform">
      {
        pComplete.map((pc,j) => {
          return (<p key={j} dangerouslySetInnerHTML={{__html: pc.innerHTML}}></p>);
        })
      }
    </div>
  );
}
export default FormComplete;